<form #wompiForm action="https://checkout.wompi.co/p/" method="GET">
    <!-- OBLIGATORIOS -->
    <input type="hidden" name="public-key" value="{{publicKey}}" />
    <input type="hidden" name="currency" value="{{currency}}" />
    <input type="hidden" name="amount-in-cents" value="{{amountInCents}}" />
    <input type="hidden" name="reference" value="{{reference}}" />
    <input type="hidden" name="signature:integrity" value="{{signature}}" />
    <input type="hidden" name="redirect-url" value="{{urlRedirect}}" />
    
  </form>
  

  